import React from 'react';
import ArticleLink from '../models/ArticleLink';
import { ArticleLinkCardStyle } from './ArticleLinkCard';
import ArticleLinkCardList from './ArticleLinkCardList';

interface TitledArticleLinkCardListProps {
  articleLinks: ArticleLink[];
  style: ArticleLinkCardStyle;
  title: string;
  showAds?: boolean;
  showMoreButton?: boolean;
  hidePrimaryTaxonomy?: boolean;
}

export default class TitledArticleLinkCardList extends React.PureComponent<TitledArticleLinkCardListProps> {
  render() {
    return (
      <div className="titled-article-link-card-list">
        <h2 className="titled-article-link-card-list__title">{this.props.title}</h2>
        <ArticleLinkCardList
          articleLinks={this.props.articleLinks}
          style={this.props.style}
          showAds={this.props.showAds}
          showMoreButton={this.props.showMoreButton}
          hidePrimaryTaxonomy={this.props.hidePrimaryTaxonomy}
        />
      </div>
    );
  }
}
